import * as React from "react";

import { Card as BCard } from "bloomer";
import styled from "react-emotion";
import { Redirect } from "react-router";
import LoginForm from "./LoginForm";
import Register from "./Register";
import ForgotPassword from "./ForgotPassword";
import { isLoggedIn } from "../../utils/auth";

const Card = styled(BCard)`
  background: #ebf1f5;
  padding-bottom: 100px;
`;

const LoginPage = styled("div")`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  height: 100%;
  width: 100%;
`;

const LoginContent = styled(Card)`
  margin: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 400px;
  min-height: 400px;
  padding: 0;
`;

interface ILoginState {
  loading: boolean;
  activeTab?: string;
}

interface ILoginProps {
  onUpdateUserContext?: any;
  activeTab?: string;
}

class Login extends React.Component<ILoginProps, ILoginState> {
  public constructor(props: ILoginProps) {
    super(props);

    this.state = {
      loading: false,
      activeTab: props.activeTab || "login"
    };
  }

  public render() {
    return (
      <LoginPage>
        <LoginContent>
          {isLoggedIn() && <Redirect to="/models" />}
          {this.state.activeTab === "registered" && <Redirect to="/thankyou" />}
          {this.state.activeTab === "login" && (
            <LoginForm
                switch={this.setActiveTab}
                updateUserContext={(user: any) => {
                  this.props.onUpdateUserContext(user);
                }}
            />
          )}
          {this.state.activeTab === "signup" && (
            <Register switch={this.setActiveTab} />
          )}
          {this.state.activeTab === "forgot" && (
            <ForgotPassword switch={this.setActiveTab} />
          )}
        </LoginContent>
      </LoginPage>
    );
  }

  private setActiveTab = (value: string) => {
    this.setState({
      activeTab: value
    });
  };
}

export default Login;



// WEBPACK FOOTER //
// ./src/routes/Login/NewLogin.tsx